import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import './AccessorySalePreviewModal.css';
import './AccessorySaleDetailModal.css';

const money = value => `S/ ${Number(value || 0).toFixed(2)}`;

export default function AccessorySaleDetailModal({ detail, registerId, onClose, canManageCancellation = false }) {
  const [notes, setNotes] = useState(null);
  const [stock, setStock] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [reasonCode, setReasonCode] = useState('01');
  const [reason, setReason] = useState('Anulación total de venta de accesorios');
  const [returned, setReturned] = useState(false);
  const [refunded, setRefunded] = useState(false);
  const base = (process.env.REACT_APP_API || '/api').replace(/\/$/, '');
  const saleId = Number(detail?.id);
  const refresh = useCallback(async () => {
    if (!saleId) return;
    const [n, s] = await Promise.all([
      axios.get(`${base}/accessory-sales/${saleId}/credit-notes`, {withCredentials:true}),
      axios.get(`${base}/accessory-sales/${saleId}/credit-notes/stock-status`, {withCredentials:true})
    ]);
    setNotes(n.data.data); setStock(s.data.data);
  }, [base, saleId]);
  useEffect(() => { refresh().catch(e => setError(e.response?.data?.message || 'No se pudo consultar el estado SUNAT.')); }, [refresh]);
  const execute = async (operation) => {
    if (busy) return;
    setBusy(true); setError(''); setMessage('');
    try {
      if (operation === 'issue') {
        if (!returned || !refunded || reason.trim().length < 5) throw new Error('Confirme devolución, reembolso y sustento de al menos 5 caracteres.');
        await axios.post(`${base}/accessory-sales/${saleId}/credit-notes/issue`, {reasonCode,reason:reason.trim(),confirmReturned:true,confirmRefunded:true},{withCredentials:true});
        setMessage('Solicitud procesada. Revise los estados SUNAT antes de restituir el stock.');
      } else {
        if (!window.confirm('¿Confirma la restitución del inventario? Esta operación no debe ejecutarse dos veces.')) return;
        const response = await axios.post(`${base}/accessory-sales/${saleId}/credit-notes/restore-stock`, {},{withCredentials:true});
        const result = response.data?.data || response.data;
        if (result?.register?.registerState === '0') {
          setMessage('Anulación completada. El registro ya no contabiliza en los KPI.');
          window.location.reload();
          return;
        }
        setMessage('Restitución procesada. Consulte el estado del registro.');
      }
      await refresh();
    } catch(e) { setError(e.response?.data?.message || e.message || 'No se pudo completar la operación.'); }
    finally { setBusy(false); }
  };
  useEffect(() => {
    const onKey = event => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);
  if (!detail) return null;
  const items = Array.isArray(detail.items) ? detail.items : [];
  const units = items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  const total = Number(detail.total_amount || 0);
  return (
    <div className="acc-overlay" onMouseDown={event => { if (event.target === event.currentTarget) onClose(); }}>
      <section className="acc-modal acc-detail-modal" role="dialog" aria-modal="true" aria-labelledby="acc-detail-title">
        <header className="acc-header">
          <div><small>MOVILESPAY · REGISTROS · CONTADO</small><h2 id="acc-detail-title">Detalle de venta #{registerId}</h2><p>Productos y cantidades registrados en esta operación</p></div>
          <button type="button" onClick={onClose} aria-label="Cerrar detalle">×</button>
        </header>
        <div className="acc-detail-content">
          <div className="acc-detail-summary"><span>{items.length} {items.length === 1 ? 'producto' : 'productos'} · {units} {units === 1 ? 'unidad' : 'unidades'}</span><strong>{String(detail.status || 'VENTA').replaceAll('_', ' ')}</strong></div>
          <div className="acc-detail-scroll"><table className="acc-detail-table"><thead><tr><th>Accesorio</th><th>Cantidad</th><th>Precio unitario</th><th>Subtotal</th></tr></thead><tbody>{items.map((item, index) => <tr key={item.id || `${item.product_id}-${index}`}><td><strong>{item.description}</strong>{item.sku && <small>SKU: {item.sku}</small>}</td><td>{item.quantity}</td><td>{money(item.unit_price)}</td><td><strong>{money(item.line_total)}</strong></td></tr>)}</tbody></table></div>
          <div className="acc-detail-total"><span>Total de la venta</span><strong>{money(total)}</strong></div>
        </div>
        <footer className="acc-detail-footer"><button type="button" onClick={onClose}>Cerrar detalle</button></footer>
      </section>
    </div>
  );
}
